/**
 * Utilidades para calculo y formateo de duracion de tiempo
 *
 * Usadas en ActividadesOrdenTrabajoList para tracking de tiempo.
 */

/**
 * Calcula la diferencia en minutos entre dos fechas
 *
 * @param {string|Date} fechaInicio - Fecha de inicio (DATETIME de BD)
 * @param {string|Date} fechaFin - Fecha de fin (DATETIME de BD)
 * @returns {number} Diferencia en minutos, o 0 si datos invalidos
 */
export function calcularDuracionMinutos(fechaInicio, fechaFin) {
  if (!fechaInicio || !fechaFin) return 0;
  const inicio = new Date(fechaInicio);
  const fin = new Date(fechaFin);
  const diffMs = fin - inicio;
  return diffMs > 0 ? Math.floor(diffMs / 60000) : 0;
}

/**
 * Formatea minutos a texto legible (ej: "2h 15min")
 *
 * @param {number} minutes - Minutos a formatear
 * @returns {string} Duracion formateada
 */
export function formatDuration(minutes) {
  if (!minutes || minutes < 0) return '-';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}min`;
  return `${h}h ${m}min`;
}

/**
 * Formatea segundos a formato HH:MM:SS para timer en vivo
 *
 * @param {number} totalSeconds - Total de segundos
 * @returns {string} Tiempo formateado "HH:MM:SS"
 */
export function formatDurationSeconds(totalSeconds) {
  if (!totalSeconds || totalSeconds < 0) return '00:00:00';
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
